import React, { useEffect } from "react";
import { OcErrorBoundary, OcRoleFilter } from "oc/components";
import useOcButtonGroup from "oc/hooks/use-button-group";
import { useTranslation } from "react-i18next";

type AllLeavesCardLeaveFilterCollapseProps = {
  buttonDisable: boolean;
  currentDate: Date;
  data: {
    allUsersCount?: number;
    allLeavesCount?: number;
    [key: string]: any;
  };
  filterable: boolean;
  monthFiltering: boolean;
  onAddFilter: (...args: any[]) => void;
  onClearFilters: () => void;
  onCurrentDateChange: (date: Date) => void;
  onFilterableChange: (value: boolean) => void;
  onLoadQuery: () => void;
  onRemoveFilter: (...args: any[]) => void;
  onShowRemoteWorksChange: (newValue: boolean) => void;
  product: any;
  role: any;
  roleFilters: any;
  setOnlyRequested: (value: boolean) => void;
  showRemoteWorks: boolean;
  contract: any;
  examinerDasboard: boolean;
  loading: boolean;
};

export const AllLeavesCardLeaveFilterCollapse = ({
  buttonDisable,
  data,
  filterable,
  onAddFilter,
  onClearFilters,
  onFilterableChange,
  onLoadQuery,
  onRemoveFilter,
  onShowRemoteWorksChange,
  product,
  role,
  roleFilters,
  setOnlyRequested,
  showRemoteWorks,
  examinerDasboard,
}: AllLeavesCardLeaveFilterCollapseProps) => {
  const { t } = useTranslation();

  const buttonsDef = ["OC_TO_BE_ASSESSED", "OC_ALL"];
  const { OcButtonGroup, selectedButton } = useOcButtonGroup({
    id: "LeaveFilterCollapse",
    buttonsDef,
  });

  useEffect(() => {
    if (!examinerDasboard && selectedButton === "OC_TO_BE_ASSESSED") {
      setOnlyRequested(true);
    } else if (!examinerDasboard && selectedButton === "OC_ALL") {
      setOnlyRequested(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedButton]);

  const handleFilter = () => {
    onFilterableChange(true);
    onLoadQuery();
  };

  let switchesDef = undefined;
  let roleFilterButtonGroup = undefined;

  if (!examinerDasboard) {
    switchesDef = [
      {
        handleSwitchChange: () => onShowRemoteWorksChange(!showRemoteWorks),
        label: "MY_LEAVE_SHOW_OTHER_ABSENCES",
        selected: showRemoteWorks,
      },
    ];

    roleFilterButtonGroup = OcButtonGroup;
  }

  return (
    <OcErrorBoundary>
      <OcRoleFilter
        subtypeProps={{
          roleFilters: roleFilters,
          product: product,
          role: role,
          handleAddItem: onAddFilter,
          handleRemoveItem: onRemoveFilter,
          isCheckbox: true,
          queryType: "notAdmin",
        }}
        summaryItems={[
          {
            label: "OC_TOTAL_COUNT_OF_EMPLOYEES",
            value: data?.allUsersCount,
          },
          {
            label: "OC_COUNT_OF_REQUESTS",
            value: data?.allLeavesCount,
            color: "primary",
          },
        ]}
        buttonBarProps={{
          handlePrimaryButton: handleFilter,
          primaryButtonDisabled: filterable || buttonDisable,
          handleRightButton: onClearFilters,
          paddingTop: "10px",
          rightButtonText: t("OC_RESET"),
          rightButtonId: "cancel-button",
          rightButtonColor: "secondary",
          primaryButtonText: t("OC_FILTERING"),
          primaryButtonId: "filter-button",
          noLine: true,
        }}
        switchesDef={switchesDef}
        OcButtonGroup={roleFilterButtonGroup}
      />
    </OcErrorBoundary>
  );
};

export default AllLeavesCardLeaveFilterCollapse;
